Vendd.Scripts.load(function () {
    if (venddProjectConfigs.phoneLocalizationEnabled) {
        initPhoneLocalization();
    }  
});

function initPhoneLocalization() {

    var formRow = document.getElementsByClassName("js-phone-localization");

    if (formRow.length < 1) return;

    for (var i = 0; i < formRow.length; i++) {
        initPlugin(formRow[i]);
    }
}

function initPlugin(item) {

    var input = item.querySelector("input");

    if (input.length < 1) return;

    var validationType = input.getAttribute("data-validation");
    var iti, itiOptions;

    var defaultItiOptions = {
        initialCountry: LhApp.Context.Country.toLowerCase(),
        preferredCountries: [LhApp.Context.Country.toLowerCase()],
        //excludeCountries: [],
        //onlyCountries: [],
        autoPlaceholder: 'aggressive',
        formatOnDisplay: false
    };

    if (validationType === "phone") {
        itiOptions = $.extend({}, defaultItiOptions, { placeholderNumberType: 'FIXED_LINE' });
    } else if (validationType === "mobile") {
        itiOptions = $.extend({}, defaultItiOptions, { placeholderNumberType: 'MOBILE' });
    } else if (validationType === "both") {
        itiOptions = $.extend({}, defaultItiOptions, { placeholderNumberType: 'FIXED_LINE_OR_MOBILE' });
    } else {
        itiOptions = defaultItiOptions;
    }

    iti = window.intlTelInput(input, itiOptions);

    // on blur: add country phone code
    if (venddProjectConfigs.phoneLocalizationAutoCompleteCode) {
        input.addEventListener('blur', function () {
            if (input.value.trim()) {
                if (iti.isValidNumber()) {
                    var fullNumber = iti.getNumber();
                    input.value = fullNumber;
                }
            }
        });
    }
}